import Vue from 'vue';
//helper
import Account from '@/helper/AccountHelper.js';
import ThemeHelper from '@/helper/ThemeHelper.js';
import Locale from "@/helper/locale/locale.js";
//core
import { CallbackEvent } from "@/core/Utility/CallbackEvent.js";
//service
import BzbsCampaign from '@/core/Campaign/service/BzbsCampaign.js';
//custom service
import { AIARedeemConfigModel } from '@/core/Custom/config/AIARedeemConfigModel.js';
import { QuotaConfigBuilder } from '@/core/Custom/config/QuotaConfigModel.js';
import AIAService from '@/core/Custom/service/AIAService.js';
import RewardService from '@/core/Custom/service/RewardService.js';
//store
import store from '@/store/Store.js';
export function DetailController () {
    this.lbl = Locale.getLbl();
    this.profileExtensionJson = Account.getCacheProfileExtensionJson();

    this.isLoading = false;
    this.campaignConfig = null;
    this.campaign = {};
    this.campaignId = null;
    this.type = '';
    this.point = 0;
    this.pointType = '';
    this.price = 0;
    this.originalPrice = 0;
    this.discount = 0;
    this.qty = 0;
    this.quantity = 0;
    this.isFavorite = false;
    //custom
    this.isAmbassadorCat = false;
    this.ambassadorCatId = null;
    this.quota = null;
    this.campaignGroup = '';
    this.aiaForwardData = null;
    this.customRedeemConfig = new AIARedeemConfigModel();
    this.redeemOnce = false;

    this.isSendToFriend = false;
    //modal
    this.modalController = null;
    //event
    this.cbApiResponseError = new CallbackEvent();
    this.cbGetCampaignSuccess = new CallbackEvent();
    this.cbRedeemSuccess = new CallbackEvent();
    this.cbUpdatePoint = new CallbackEvent();
    //before redeem
    this.cbShoppingCart = new CallbackEvent();
    this.cbOpenWeb = new CallbackEvent();
    this.cbOpenSurvey = new CallbackEvent();
    this.cbCallApi = new CallbackEvent();
    this.cbShipping = new CallbackEvent();
    this.cbRedeem = new CallbackEvent();
    this.cbOpenIframe = new CallbackEvent();
    //custom
    this.cbSendToFriend = new CallbackEvent();

    //#region setup
    this.initialCampaign = function (campaignConfig, controller, ambassadorCatId) {
        this.campaignConfig = campaignConfig;
        this.modalController = controller;
        this.ambassadorCatId = ambassadorCatId;
        this.getCampaignDetail();
    };
    this.updateCampaignInfo = function () {
        this.campaignId = this.campaign.id;
        this.type = this.campaign.type;
        this.point = this.campaign.pointPerUnit;
        this.pointType = this.campaign.pointType;
        this.price = this.campaign.pricePerUnit;
        this.originalPrice = this.campaign.originalPrice;
        this.discount = this.campaign.discount;
        this.qty = this.campaign.qty;
        this.quantity = this.campaign.quantity;
        this.isFavourite = this.campaign.isFavourite;
    };
    this.selectSubCampaign = function (selectedItem) {
        this.campaignId = selectedItem.id;
        this.type = selectedItem.type;
        this.point = selectedItem.pointPerUnit;
        this.price = this.campaign.pricePerUnit;
        this.originalPrice = this.campaign.originalPrice;
        this.discount = this.campaign.discount;
        this.quantity = selectedItem.quantity;
    };
    //#endregion setup

    //#region campaign
    this.getCampaignDetail = function (isByPassLoading) {
        if(!isByPassLoading) {
            if (this.showLoading()) return;
        } else {
            this.isLoading = true;
        }

        var jwt = Account.getToken();
        // console.log('jwt', jwt);
        
        BzbsCampaign.apiGetCampaignCustom(jwt, this.campaignConfig)
            .then(res => {
                // console.log('getCampaignDetail res', res);
                this.campaign = res;
                this.updateCampaignInfo();

                // return this.getCampaignQuotaInfo();
            }).then(res => {
                //set quota
                if (res && res.length > 0) this.quota = {...res[0]};

                // set campaignGroup from meta.group
                if (this.campaign && this.campaign.meta && this.campaign.meta.group) {
                    this.campaignGroup = this.campaign.meta.group.toLowerCase();
                } else {
                    this.campaignGroup = 'default';
                    if (this.campaign.type == Vue.CampaignType.Draw)
                        this.campaignGroup = 'draw';
                }
            
                // check isAmbassadorCat from quota (if have)
                if (this.quota) {
                    this.isAmbassadorCat = (this.quota.Tier.toLowerCase() == "ambassador");
                }
            
                if ((this.campaignGroup == 4) && (!this.redeemOnce)) {
                    if ((!this.campaign.isConditionPass
                        && this.campaign.conditionAlertId == 2)
                        || (this.quota && this.quota.Available <= 0
                        && !this.isAmbassadorCat)) {
                        this.modalController.confirmModal
                            .clearModal()
                            .setTitle(this.lbl.detail.max_group_4)
                            .setMsg(this.lbl.detail.msg_max_group_4)
                            .setBtnConfirm(this.lbl.default.btn_coupon)
                            .setBtnCancel(this.lbl.default.close)
                            .show();
                        this.modalController.confirmModal
                            .cbConfirm.onCallback(() => {
                                this.clickToMyCoupon();
                        });
                        // this.modalController.noInternetModal
                        //     .clearModal()
                        //     .setMsg(this.lbl.detail.max_group_4)
                        //     .setBtnClose(this.lbl.default.close)
                        //     .show();
                    }
                }

                
                // if (this.quota) {
                //     this.campaignGroup = this.quota.Group.toLowerCase();
                //     this.isAmbassadorCat = (this.quota.Tier.toLowerCase() == "ambassador");
                // } else {
                //     this.campaignGroup = 'default';
                //     if (this.campaign.type == Vue.CampaignType.Draw)
                //         this.campaignGroup = 'draw';
                // }

                // if ((this.campaignGroup == 4) && (!this.redeemOnce)) {
                //     if ((!this.campaign.isConditionPass
                //         && this.campaign.conditionAlertId == 2)
                //         || (this.quota.Available <= 0
                //         && !this.isAmbassadorCat)) {
                //         this.modalController.noInternetModal
                //             .clearModal()
                //             .setMsg(this.lbl.detail.max_group_4)
                //             .setBtnClose(this.lbl.default.close)
                //             .show();
                //     }
                // }

                this.hideLoading();
                this.cbGetCampaignSuccess.sendCallback();
            }).catch(err => {
                this.hideLoading();
                this.cbApiResponseError.sendCallback(err);
            });
    };
    this.clickToMyCoupon = function () {
        var deepLink = this.getDeeplinks().my_coupon || '';
        console.log('clickToMyCoupon deepLink', deepLink);

        window.location.href = deepLink;
    };
    this.getDeeplinks = function () {
        return store.state.deeplinks || {};
    };
    //#endregion campaign

    //#region Custom
    this.getCampaignQuotaInfo = function () {
        var token = Account.getToken();
        var params = new QuotaConfigBuilder()
                        .setCatId(this.campaign.categoryID)
                        .create()
                        .getParams();

        return AIAService.apiGetUserQuota(token, params);
    };
    //#endregion Custom

    //#region confirm redeem
    this.confirmRedeem = function () {
        if (this.campaign.type == Vue.CampaignType.Interface) {
            switch (this.campaign.interfaceDisplay) {
                case 'web':
                    this.cbOpenWeb.sendCallback(this.campaign.website);
                    break;
                case 'survey':
                case 'surveyapprove':
                    this.cbOpenSurvey.sendCallback();
                    break;
                case 'api':
                    this.cbCallApi.sendCallback();
                    break;
            }
        } else if (this.campaign.type == Vue.CampaignType.Buy) {
            this.cbShoppingCart.sendCallback(this.campaign.website);
        } else if (this.campaign.delivered) {
            // this.modalController.shippingModal
            //     .clearModal()
            //     .setTitle(this.lbl.shipping.detail_headline)
            //     .setTag('detail-shipping')
            //     .setPage('detail')
            //     .show();

            // this.modalController.shippingModal
            //     .onSelected(address => {
            //         this.redeem(address);
            //     });
            this.redeem();
            this.cbShipping.sendCallback();
        } else {
            this.redeem();
            this.cbRedeem.sendCallback();
        }
    };
    //#endregion confirm redeem

    //#region redeem
    this.clickRedeem = function () {
        this.modalController
            .confirmRedeemModal
            .clearModal()
            .setCampaign(this.campaign)
            .setCampaignGroup(this.campaignGroup)
            .setIsAmbassadorCat(this.isAmbassadorCat)
            .show()

        this.modalController
            .confirmRedeemModal
            .cbConfirm.onCallback(() => {
                this.isSendToFriend = false;
                this.checkCaption();
                // this.confirmRedeem(data);
            });

        this.modalController
            .confirmRedeemModal
            .cbCancel.onCallback(() => {
                console.log('cancel');
            });
            
         
        // new code for send to friend - 01/12/2025
        this.modalController.confirmRedeemModal
            .cbSendToFriend.onCallback(() => {
                this.customRedeemConfig.setTransfer();
                this.isSendToFriend = true;
                this.checkSendToFriend();
        });

        // old code for send to friend - 01/12/2025
        // this.modalController
        // .confirmRedeemModal
        // .cbSendToFriend.onCallback(() => {
        //     this.customRedeemConfig.setTransfer();
        //     this.modalController.confirmModal
        //         .setTag('confirm-transfer')
        //         .setTitle(this.lbl.detail.send_to_friend_title)
        //         .setMsg(this.lbl.detail.send_to_friend_msg)
        //         .show();

        //     this.modalController.confirmModal
        //         .cbConfirm.onCallback(() => {
        //             this.isSendToFriend = true;
        //             // this.redeem();
        //             this.checkSendToFriend();
        //         });
        // });
    };
    //#region custom - customer level (WI #878678)
    /**
     * Get the Customer Level Status from the current session (no API call).
     * Reads the tier data cached at login and formats it per BR-2
     * (single = "S", ambassador = "S|Am").
     * @return {string|null} Customer Level string, or null when unavailable.
     */
    this.getCustomerLevel = function () {
        var userDetail = Account.getCacheUserDetail();
        return ThemeHelper.getCustomerLevel(userDetail);
    };
    /**
     * Whether the session currently has a Customer Level value.
     * Used to block redeem on the frontend when missing (BR-3 / AC-4).
     * @return {boolean}
     */
    this.hasCustomerLevel = function () {
        var level = this.getCustomerLevel();
        return !!(level && String(level).trim());
    };
    //#endregion custom - customer level

    this.redeem = function (params) {
        //#region custom - block redeem without Customer Level (WI #878678, BR-3 / AC-4)
        // Check before showLoading() so loadingModal is never left open on early return.
        if (!this.hasCustomerLevel()) {
            return;
        }
        //#endregion custom

        if (this.showLoading()) return;

        if (!params) {
            params = {};
        }
        
        //  new field for campaign detail api - 01/12/2025
        if (!params.CampaignId) {
            params.CampaignId = this.campaignId;
        }

        //#region custom - send Customer Level Status with redeem request (WI #878678, BR-1/BR-2)
        // Use the value already loaded in session; do NOT call any API to refresh it.
        // Request field name confirmed as "info3" (WI #878678 Q1).
        var customerLevel = this.getCustomerLevel();
        if (customerLevel) {
            params.info3 = customerLevel;
        }
        //#endregion custom
        
        // check if pointServices is true - 01/12/2025
        if (this.campaign.pointServices && 
            this.campaign.pointServices.credit !== null &&
            this.campaign.pointServices.credit !== undefined &&
            this.campaign.pointServices.credit.unit) {
            params.PointUnit = this.campaign.pointServices.credit.unit;
        }
        
        // if (this.campaign.meta && this.campaign.meta.pointServices === true) {
        //     if (this.campaign.pointServices && 
        //         this.campaign.pointServices.credit && 
        //         this.campaign.pointServices.credit.unit) {
        //         params.PointUnit = this.campaign.pointServices.credit.unit;
        //     }
        // }
       
        // for new redeem api
        var token = Account.getToken();
        RewardService.apiRedeemCampaignCustom(token, params)
            .then(res => {
                this.redeemOnce = true;
                this.campaign.updateAfterRedeem(res);
                this.updateCampaignInfo();

                //#region Custom section
                /**
                 * aiaForwardData : Data for redirect to AIA Website.
                 */
                this.aiaForwardData = res.PrivilegeMessage;
                //#endregion Custom section

                this.hideLoading(true);
                var captions = null;
                var telCaption = null;
                if (this.campaign.caption != null && this.campaign.caption != "") {
                    captions = this.campaign.caption.split('|');
                    telCaption = captions.filter(captionVal => {
                        return (captionVal.indexOf('tel.') >= 0);
                    });
                }
                if (telCaption && telCaption.length > 0) {
                    var tel = telCaption[0].replace('tel.', '');
                    window.location = `tel:${tel}`;
                    // const channel = this.profileExtensionJson.Tier.CHANNEL;
                    // var url = '';
                    // if (channel == 'aiaplus') {
                    //     url = Vue.bzbsConfig.aiaPlusPhoneUrl + tel
                    //     window.open(url);
                    // } else {
                    //     url = Vue.bzbsConfig.aiaPhoneUrl + tel
                    //     window.location.href = url;
                    // }
                } else if (!this.isSendToFriend) {
                    if (this.type == Vue.CampaignType.Draw) {
                        this.initDraw();
                    } else {
                        this.initSerial();
                    }
                } else {
                    this.isSendToFriend = true;
                    this.redirectAiaWebsite();
                }


                // console.log('res.updated_points', res);
                //wait for db update.
                setTimeout(() => {
                    this.cbUpdatePoint.sendCallback({
                        updated_points: res.updated_points,
                        pointServiceBalance: res.PointServiceBalance,
                        pointServiceAmount: res.PointServiceAmount,
                        pointServiceUnit: res.PointServiceUnit
                    });
                    this.getCampaignDetail(true);
                }, 1500);
                // setTimeout(() => {
                //     this.getCampaignDetail(true);
                //     this.cbUpdatePoint.sendCallback(res.updated_points);
                // }, 1500);
            }).catch(err => {
                this.hideLoading();
                this.cbApiResponseError.sendCallback(err);
            });

        // var token = Account.getToken();
        // RewardService.apiRedeemCampaign(token, this.campaignId, params)
        //     .then(res => {
        //         this.redeemOnce = true;
        //         this.campaign.updateAfterRedeem(res);
        //         this.updateCampaignInfo();

        //         //#region Custom section
        //         /**
        //          * aiaForwardData : Data for redirect to AIA Website.
        //          */
        //         this.aiaForwardData = res.PrivilegeMessage;
        //         //#endregion Custom section

        //         this.hideLoading(true);
        //         var captions = null;
        //         var telCaption = null;
        //         if (this.campaign.caption != null && this.campaign.caption != "") {
        //             captions = this.campaign.caption.split('|');
        //             telCaption = captions.filter(captionVal => {
        //                 return (captionVal.indexOf('tel.') >= 0);
        //             });
        //         }
        //         if (telCaption && telCaption.length > 0) {
        //             var tel = telCaption[0].replace('tel.', '');
        //             window.location = `tel:${tel}`;
        //             // const channel = this.profileExtensionJson.Tier.CHANNEL;
        //             // var url = '';
        //             // if (channel == 'aiaplus') {
        //             //     url = Vue.bzbsConfig.aiaPlusPhoneUrl + tel
        //             //     window.open(url);
        //             // } else {
        //             //     url = Vue.bzbsConfig.aiaPhoneUrl + tel
        //             //     window.location.href = url;
        //             // }
        //         } else if (!this.isSendToFriend) {
        //             if (this.type == Vue.CampaignType.Draw) {
        //                 this.initDraw();
        //             } else {
        //                 this.initSerial();
        //             }
        //         } else {
        //             this.isSendToFriend = true;
        //             this.redirectAiaWebsite();
        //         }

        //         //wait for db update.
        //         setTimeout(() => {
        //             this.getCampaignDetail(true);
        //             this.cbUpdatePoint.sendCallback(res.updated_points);
        //         }, 1500);
        //     }).catch(err => {
        //         this.hideLoading();
        //         this.cbApiResponseError.sendCallback(err);
        //     });
    };
    this.checkSendToFriend = function () {
        this.customRedeemConfig.setCaption(this.campaign.caption);
        var params = this.customRedeemConfig.getParams();
        
        this.redeem(params);
    };
    this.checkCaption = function () {
        if (this.campaign.caption != null && this.campaign.caption != "") {
            var params = {};
            params.info1 = this.campaign.caption;
            this.redeem(params);
        } else {
            this.confirmRedeem();
        }
    };
    //#endregion redeem
    //#region serial
    this.initDraw = function () {
        this.modalController.drawDeliveryModal
            .setCampaign(this.campaign)
            .setTag('draw')
            .show();

        this.modalController.drawDeliveryModal
            .cbAction.onCallback(data => {
                if (data) {
                    if (data.action == 'history')
                        this.cbRedeemSuccess.sendCallback({type: 'route', link: '/history/burn'});
                }
            });
    },
    this.initSerial = function () {
        if (this.campaignGroup == '4' || this.campaignGroup == '8') { // || this.campaignGroup == '8'
            //Redirect
            this.redirectAiaWebsite();
        } else {
            this.modalController.serialModal
                .setCampaign(this.campaign)
                .setCampaignGroup(this.campaignGroup)
                .setIsAmbassadorCat(this.isAmbassadorCat)
                .setTag('detail')
                .show();

            this.modalController.serialModal
                .cbAction.onCallback(data => {
                    if (data) {
                        switch (data.action) {
                            case 'history':
                                this.cbRedeemSuccess.sendCallback({type: 'route', link: '/history/burn'});
                                break;
                            case 'redirect-aia':
                                this.redirectAiaWebsite();
                                break;
                        }
                    }
                });
            // this.modalController
            //     .serialModal
            //     .cbClose.onCallback(data => {
            //         console.log(data);
            //     });
        }
    };
    this.redirectAiaWebsite = function () {
        this.isSendToFriend = false;
        if (this.aiaForwardData) {
            try {
                var forwardData  = JSON.parse(this.aiaForwardData);
                //var encodedUrl = encodeURI(forwardData.AiaWeb);
                this.cbRedeemSuccess.sendCallback({type: 'relocation', link: forwardData.AiaWeb});
            } catch (e) {
                this.modalController.alertModal
                    .clearModal()
                    .setMsg('Parse forward data fail')
                    .show();
            }
        } else {
            this.modalController.alertModal
                .clearModal()
                .setMsg('Require URL')
                .show();
        }
    };
    //#endregion serial

    //#region loading
    this.showLoading = function () {
        if (this.isLoading) return true;
        this.isLoading = true;

        this.modalController.loadingModal.show();
    };
    this.hideLoading = function (isLoading) {
        this.isLoading = (isLoading);
        this.modalController.loadingModal.hide();
    };
    //#endregion
}
